import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checkhistory');
import { OnInit, ChangeDetectorRef, NgZone } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-checkhistory',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checkhistory/view.scss */
/* src/app/component.checkhistory/view.scss: no such file or directory */`],
})
export class ComponentCheckhistoryComponent implements OnInit {
  public totalCount: number = 0;
  public approvalRate: number = 0;
  public averageScore: number = 0;
  public history: any[] = [];

  constructor(@Inject( Service)     public service: Service,@Inject( ChangeDetectorRef)     private cdr: ChangeDetectorRef,@Inject( NgZone  )     private zone: NgZone  ) { }

  public async ngOnInit() {
    await this.service.init();

    const dummyData = [
      {
        status: "승인",
        rating: 5,
        title: "황제내경 벡터DB - 2025. 10. 16. 08:36",
        category: "theory",
        question: "황제내경에서 말하는 상고시대 사람들의 양생법은?",
        comment: "우수한 내용입니다. 임상에서 활용 가능합니다.",
        date: "2025년 10월 16일 오후 05:37",
      },
      {
        status: "승인",
        rating: 4,
        title: "동의보감 벡터DB - 2025. 10. 16. 08:36",
        category: "theory",
        question: "음양오행에서 오행의 생극관계를 설명하시오.",
        comment: "상극 관계에 대한 보충 설명이 있으면 더 좋습니다.",
        date: "2025년 10월 16일 오후 05:37",
      },
    ];

    // ✅ Angular Zone 안에서 값 갱신
    this.zone.run(() => {
      this.history = dummyData;
      this.totalCount = this.history.length;
      this.approvalRate = 83;
      this.averageScore = 3.7;

      console.log("🔥 history 데이터 바인딩 완료:", this.history);
      this.cdr.detectChanges(); // 👈 강제 렌더링
    });
  }
}

export default ComponentCheckhistoryComponent;